import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm, ColumnResource } from 'shared/types';
import WizardConfigurationStage from './WizardConfigurationStage';
import WizardStage from './WizardStage';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: auto;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  stage: number;
  columnsResourcesData: ColumnResource[];
};

const EditTestWizardStages = ({
  methods,
  stage,
  columnsResourcesData,
}: Props) => (
  <Wrapper>
    <WizardStage
      $index={1}
      $selectedIndex={stage}
      $fillHeight={methods.watch('testType') === 'yamlTest'}
    >
      <WizardConfigurationStage
        methods={methods}
        columnsResourcesData={columnsResourcesData}
        editMode
      />
    </WizardStage>
  </Wrapper>
);

export default EditTestWizardStages;
